import { CandidateCardModule } from './candidateCard/candidate-card.module';
import { CandidatesPageComponent } from "./candidates-page.component";
export const CandidatesPageModule = angular
    .module('candidatesPage', [CandidateCardModule])
    .config(['$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('missioncontrol.candidates', {
            url: '/candidates',
            component: CandidatesPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                candidateStatuses: null,
                recruiters: null,
                visibilityFilters: null,
                searchString: null,
                candidateType: null
            }
        });
    }
])
    .component(CandidatesPageComponent.selector, CandidatesPageComponent.component)
    .name;
//# sourceMappingURL=candidates-page.module.js.map